import { useState, useEffect } from 'react'
import { FaNewspaper, FaImage, FaCircle, FaShare, FaRetweet, FaCalendarAlt, FaPhotoVideo, FaFileAlt } from 'react-icons/fa'
import { IoSettingsOutline } from 'react-icons/io5'
import { useNavigate } from 'react-router-dom'
import { Grid, GridItem } from '@chakra-ui/react'
import { SettingsCard } from '../../../components/SettingsCard'
import './gridPublicacao.scss'

const GridPublicacao = () => {
  const navigate = useNavigate()
  const [submenus, setSubmenus] = useState<any[]>([])

  useEffect(() => {
    const permissaoAcessos = localStorage.getItem('permissaoAcesso')
    if (permissaoAcessos) {
      const parsedPermissaoAcesso = JSON.parse(permissaoAcessos)

      const publicacaoSubmenus = parsedPermissaoAcesso
        .filter((item: any) => item.menuDTO.fkCodMenu === 10000)
        .map((item: any) => {
          let path = `/cms/publicacao/${item.menuDTO.dscMenu.toLowerCase().replace(/\s+/g, '-')}`;
          let icon;
          
          if (item.menuDTO.codMenu === 11000) {
            icon = FaNewspaper;
            path = '/cms/publicacao/noticia';
          } else if (item.menuDTO.codMenu === 12000) {
            icon = FaImage;
            path = '/cms/publicacao/banner';
          } else if (item.menuDTO.codMenu === 13000) {
            icon = FaRetweet;
            path = '/cms/publicacao/redes-sociais';
          } else if (item.menuDTO.codMenu === 14000) {
            icon = FaCalendarAlt;
            path = '/cms/publicacao/evento';
          } else if (item.menuDTO.codMenu === 15000) {
            icon= FaPhotoVideo;
            path = '/cms/publicacao/gerenciar-biblioteca';
          } else if (item.menuDTO.codMenu === 16000) {
            icon = FaFileAlt;
            path = '/cms/publicacao/imprensa-oficial';
          } else {
            icon = FaCircle;
          }

          return {
            cardTitle: item.menuDTO.dscMenu,
            path: path,
            icon: icon
          }
        })

      setSubmenus(publicacaoSubmenus)
    }
  }, [])

  return (
    <div className='main-container-grid'>
        {submenus.map((submenu, index) => (
          <GridItem key={index}>
            <SettingsCard
              buttonText="Acessar"
              onClick={() => navigate(submenu.path)}
              icon={submenu.icon}
              cardTitle={submenu.cardTitle}
            />
          </GridItem>
        ))}
    </div>
  )
}

export default GridPublicacao
